import { createAsyncActions } from './utils'

const reducer = 'AVAILABILITIES'

const {
  action: getApartmentAvailability,
  actionSuccess: getApartmentAvailabilitySuccess,
  actionFail: getApartmentAvailabilityFail
} = createAsyncActions(reducer, 'GET')

const {
  action: getApartmentAvailabilitiesByApplicants,
  actionSuccess: getApartmentAvailabilitiesByApplicantsSuccess,
  actionFail: getApartmentAvailabilitiesByApplicantsFail
} = createAsyncActions(reducer, 'GET_BY_APPLICANTS')

const {
  action: createApplicantAvailability,
  actionSuccess: createApplicantAvailabilitySuccess,
  actionFail: createApplicantAvailabilityFail
} = createAsyncActions(reducer, 'CREATE')

const {
  action: deleteApplicantAvailability,
  actionSuccess: deleteApplicantAvailabilitySuccess,
  actionFail: deleteApplicantAvailabilityFail
} = createAsyncActions(reducer, 'DELETE')

export {
  getApartmentAvailability,
  getApartmentAvailabilitySuccess,
  getApartmentAvailabilityFail,
  getApartmentAvailabilitiesByApplicants,
  getApartmentAvailabilitiesByApplicantsSuccess,
  getApartmentAvailabilitiesByApplicantsFail,
  createApplicantAvailability,
  createApplicantAvailabilitySuccess,
  createApplicantAvailabilityFail,
  deleteApplicantAvailability,
  deleteApplicantAvailabilitySuccess,
  deleteApplicantAvailabilityFail
}
